import React, { useContext, useReducer } from "react";

const allTest = React.createContext();

const initialState = {
  allTest: null,
  allTestStudent: null,
  selectedTest: null,
  columnFilter: [],
  notFound: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_ALL_TEST_STUDENT": {
      return {
        ...state,
        allTestStudent: action.payload,
        columnFilter: action.payload,
        notFound: false,
      };
    }
    case "SET_SELECTED_TEST": {
      return {
        ...state,
        selectedTest: action.payload,
      };
    }
    case "SET_ALL_TEST": {
      console.log("SET_ALL_TEST", action.payload);
      return {
        ...state,
        allTest: action.payload,
      };
    }

    case "TEST_LIST_COLUMN_FILTER": {
      console.log("column filter state,query", state, action.query);
      // state.columnFilter = state.allTestStudent;
      const columnfilter = state.allTestStudent?.filter((std) => {
        const fullName = `${std.firstname} ${std.lastname}`;

        const reg_fullname = new RegExp(`${action.query.name.toLowerCase()}`);
        const reg_age = new RegExp(`^${action.query.age}`);
        const reg_grade = new RegExp(
          `^${action.query.grade}${action.query.grade !== "" ? "$" : ""}`
        );
        const reg_proficiency = new RegExp(`^${action.query.proficiency}`);
        const reg_level = new RegExp(`^${action.query.level}`);

        return (
          !!fullName.toLowerCase().match(reg_fullname) &&
          !!std.age.match(reg_age) &&
          !!std.grade.match(reg_grade) &&
          !!std.proficiency.match(reg_proficiency) &&
          std.test_date.indexOf(action.query.date) > -1 &&
          !!std.grade_id.match(reg_level)
        );
      });
      console.log("testing", columnfilter);
      if (columnfilter?.length === 0) {
        return {
          ...state,
          columnFilter: columnfilter,
          notFound: true,
        };
      }
      return {
        ...state,
        columnFilter: columnfilter,
        notFound: false,
      };
    }

    case "RESET_FILTER":
      return {
        ...state,
        allTestStudent: [],
        columnFilter: [],
        notFound: false,
      };

    default:
      return state;
  }
};

export function AllTestProvider(props) {
  const [allTestC, dispatchAllTest] = useReducer(reducer, initialState);
  return <allTest.Provider value={{ allTestC, dispatchAllTest }} {...props} />;
}

export function AllTestContext() {
  const context = useContext(allTest);
  if (!context) {
    throw new Error(" Please use the context inside parent scope");
  }
  return context;
}
